import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { History, Undo2 } from "lucide-react";

const REASON = { no: "ha risposto No", no_master: "No segnato dal master", date_x: "rimosso alla data X", date_x_manual: "rimosso alla data X (esegui ora)", restore: "rimesso nel corso" };

// Registro uscite/reintegri; "Rimetti" solo sull'uscita più recente di un allievo ancora fuori
export const PreregLog = ({ year, logs, outIds, onRestored }) => {
  const restore = async (uid) => {
    try {
      const { data } = await api.post(`/admin/prereg/${uid}/restore`, { year });
      toast.success("Allievo rimesso nel corso"); onRestored(uid, data);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
  };
  const seen = new Set();
  return (
    <div className="space-y-2" data-testid="prereg-logs">
      <p className="text-sm font-semibold flex items-center gap-1.5"><History size={14} /> Registro uscite dal corso</p>
      {logs.length === 0 ? <p className="text-xs text-muted-foreground">Nessuna uscita registrata.</p> : (
        <ul className="max-h-72 overflow-y-auto divide-y divide-border rounded-lg border border-border text-xs">
          {logs.map((l) => {
            const first = !seen.has(l.user_id); seen.add(l.user_id);
            const canRestore = first && l.action === "exit" && outIds.has(l.user_id);
            return (
              <li key={l.id} className="p-2 flex items-start justify-between gap-2" data-testid={`prereg-log-${l.id}`}>
                <div className="min-w-0"><p className="break-words"><strong>{l.name || l.email}</strong> · {l.course}</p>
                  <p className="text-muted-foreground">{new Date(l.at).toLocaleString("it-IT")} · {REASON[l.reason] || l.reason}</p></div>
                {canRestore && <Button size="sm" variant="outline" className="h-7 shrink-0" data-testid={`prereg-log-restore-${l.user_id}`} onClick={() => restore(l.user_id)}><Undo2 size={13} className="mr-1" /> Rimetti</Button>}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
